class CustomFlickity extends HTMLElement {
  flickity = null;
  thumb = null;
  scrollbarWidth = 0;
  dragging = false;
  nextButton = null;
  prevButton = null;
  slidesToShow = 0;

  constructor() {
    super();
    const options = this.dataset.options ? JSON.parse(this.dataset.options) : {};
    const carouselElement = this.querySelector('[data-is-flickity]');
    this.nextButton = this.querySelector('[data-next-btn]');
    this.prevButton = this.querySelector('[data-prev-btn]');

    this.flickity = new Flickity(carouselElement, {
      ...options,
      on: {
        ready: () => {
          setTimeout(() => {
            this.dispatchEvent(new Event('flickity-ready'));
            this.initNavigation();
            this.initCustomScrollbar();
          }, 100);
        },
        select: () => {
          this.updateThumbPosition();
        }
      }
    });

  }

  initNavigation() {
    this.prevButton.addEventListener('click', () => {
      this.flickity.previous();
      this.updateThumbPosition();
    });
    this.nextButton.addEventListener('click', () => {
      this.flickity.next();
      this.updateThumbPosition();
    });
  }

  initCustomScrollbar() {
    if (!this.flickity.size) return;
    const scrollbar = this.querySelector('[data-scrollbar]');
    this.thumb = this.querySelector('[data-scrollbar-thumb]');
    this.scrollbarWidth = scrollbar.offsetWidth;

    // Calculate thumb width based on visible slides
    const visibleSlides = Math.ceil(this.flickity.size.innerWidth / this.flickity.slides[0].outerWidth);
    const thumbWidth = (visibleSlides / this.flickity.slides.length) * this.scrollbarWidth;
    this.slidesToShow = visibleSlides;
    this.thumb.style.width = `${thumbWidth}px`;

    this.updateThumbPosition();

    scrollbar.addEventListener('mousedown', (e) => {
      if (e.target !== this.thumb) {
        this.onScrollbarClick(e);
      }
    });

    this.thumb.addEventListener('mousedown', (e) => this.startDragging(e));
    this.thumb.addEventListener('touchstart', (e) => this.startDragging(e));
  }

  updateThumbPosition() {
    if (!this.dragging && this.thumb) {
      const lastPossibleSlide = this.flickity.slides.length - this.slidesToShow;
      const progress = this.flickity.selectedIndex / lastPossibleSlide;
      const thumbWidth = this.thumb.offsetWidth;
      const maxThumbTranslate = this.scrollbarWidth - thumbWidth;
      let newTranslate = progress * maxThumbTranslate;
      newTranslate = newTranslate > this.scrollbarWidth - thumbWidth ? maxThumbTranslate : newTranslate;
      this.thumb.style.transform = `translateX(${newTranslate}px)`;
    }
  }

  onScrollbarClick(e) {
    const clickX = e.offsetX;
    const progress = clickX / this.scrollbarWidth;
    const lastPossibleSlide = this.flickity.slides.length - Math.floor(this.flickity.size.innerWidth / this.flickity.slides[0].outerWidth);
    const targetIndex = Math.round(progress * lastPossibleSlide);

    this.flickity.select(targetIndex);
  }

  startDragging(e) {
    e.preventDefault();
    this.dragging = true;

    const startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const startTranslate = this.getTranslateX(this.thumb);
    const thumbWidth = this.thumb.offsetWidth;
    const maxThumbTranslate = this.scrollbarWidth - thumbWidth;
    const lastPossibleSlide = this.flickity.slides.length - Math.floor(this.flickity.size.innerWidth / this.flickity.slides[0].outerWidth);

    const onMouseMove = (e) => {
      const currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      const deltaX = currentX - startX;
      const newTranslate = Math.max(0, Math.min(startTranslate + deltaX, maxThumbTranslate));

      // Update thumb position
      this.thumb.style.transform = `translateX(${newTranslate}px)`;

      // Calculate and select the corresponding slide
      const progress = newTranslate / maxThumbTranslate;
      const targetIndex = Math.round(progress * lastPossibleSlide);
      this.flickity.select(targetIndex, false, true);
    };

    const onMouseUp = () => {
      this.dragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('touchmove', onMouseMove);
      document.removeEventListener('touchend', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('touchmove', onMouseMove);
    document.addEventListener('touchend', onMouseUp);
  }

  getTranslateX(element) {
    const style = window.getComputedStyle(element);
    const transform = style.transform;

    // If no transform is set, return 0
    if (transform === 'none' || !transform) return 0;

    // Parse the matrix values
    const matrix = transform.match(/matrix.*\((.+)\)/)[1].split(', ');

    // Return the X translation value (index 4 in 2D matrix)
    return parseFloat(matrix[4]) || 0;
  }
}

customElements.define('custom-flickity', CustomFlickity);